<template>
  <button-dialog-container
    :btn-icon="icon"
    :color-icon="'red'"
    :only-icon="true"
    :no-btn="false"
    :width-dialog="700"
    :size="getSize"
    :dialog-viewer.sync="dialog"
    :no-tool-tip="noToolTip"
    :title-tool-tip="titleToolTip"
    @ok-pushed="saveRepair"
  >
    <v-card-title> {{ $t("schedule.repairProjectPath") }} : {{ projectName }} </v-card-title>

    <div class="pl-4">
      <v-row>
        <v-col
          class="col_explorer"
          cols="4"
          wrap
          xs3
        >
          <dir-explorer
            ref="dirExplorer"
            :root-dir="mediacenterPath"
            :current-item="explorerSelection"
            :share-access="true"
            @item-selected="dirSelected"
          />
        </v-col>
        <v-col
          class="col_explorer"
          cols="8"
          wrap
          xs3
        >
          <v-row v-if="itemsFiltered.length == 0">
            <v-col
              class="text-center p-5 mt-10"
              cols="12"
            >
              <v-icon x-large>mdi-cancel</v-icon>
              <br />
              {{ $t("mediacenter.empty") }}
            </v-col>
          </v-row>
          <v-row v-else>
            <template v-for="item in itemsFiltered">
              <v-col
                :key="item.id"
                class="text-center"
                cols="4"
                wrap
                xs3
              >
                <v-card
                  class="px-4 py-5 item-repair"
                  :class="itemSelected.id == item.id ? 'selected' : ''"
                  @click="selectItem(item)"
                >
                  <v-icon
                    v-if="item.type == 'dir'"
                    large
                  >
                    mdi-folder
                  </v-icon>
                  <v-icon
                    v-if="item.type == 'file'"
                    large
                  >
                    mdi-archive-settings
                  </v-icon>
                  <br />
                  {{ item.name }}
                </v-card>
              </v-col>
            </template>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </button-dialog-container>
</template>

<script>
// Components
import buttonDialogContainer from "../Common/ButtonDialogContainer";
import dirExplorer from "../Common/DirExplorer";

// Connectors
import { ProjectConnector } from "../Database/ProjectConnector";

const ft = require("../Tools/FileTools");

export default {
  components: {
    buttonDialogContainer,
    dirExplorer,
  },
  props: {
    schedule: {
      type: Object,
      default: () => {},
    },
    getSize: {
      type: Number,
      default: 25,
    },
    icon: {
      type: String,
      default: "",
    },
    noToolTip: {
      type: Boolean,
      default: true,
    },
    titleToolTip: {
      type: String,
      default: "",
    },
    projectIdToRepair: {
      type: Number,
      default: null,
    },
    projectName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      projectConnector: new ProjectConnector(this.$store.state.user),
      dialog: false,
      mediacenterPath: "",
      explorerSelection: [],
      items: [],
      itemSelected: { id: "" },
    };
  },
  computed: {
    itemsFiltered() {
      return this.items.filter((item) => item.ext == ".zip" || item.type == "dir");
    },
  },
  mounted() {
    this.mediacenterPath = this.$store.state.config.dirs.mediacenter + this.$store.state.user.socId;

    // If dir limited for user we use this root path
    if (this.$store.state.user.dir != "") {
      this.mediacenterPath = this.$store.state.user.dir;
    }

    this.explorerSelection = [this.mediacenterPath];
    this.changeDir([this.mediacenterPath]);
  },
  methods: {
    saveRepair() {
      if (this.projectIdToRepair != null) {
        this.projectConnector
          .saveRepair(this.projectIdToRepair, this.itemSelected.path)
          .then(() => {
            let pathLink = this.itemSelected.path;
            this.schedule.projectData.not_found = 0;
            this.schedule.projectData.path = pathLink.replace("./mediacenter/" + this.$store.state.user.socId, "");
            this.schedule.projectData.name = this.itemSelected.name;
            this.$emit("schedule-repaired");
          })
          .catch((err) => {
            console.error(err);
          });
      }
    },
    dirSelected(val) {
      if (val.length > 0) {
        this.changeDir(val);
      }
    },
    changeDir(dirPath) {
      // Set current dir for direxplorer component to select it
      this.explorerSelection = dirPath;

      ft.scanFlat(this.explorerSelection[0], [".zip"]).then((response) => {
        this.items = response;
        this.sortItems();

        // Reset selected data to disable tool buttons
        this.deselect();
      });
    },
    sortItems() {
      // Sort first dirs and files after
      this.items = this.items.sort(function (a, b) {
        if (a.type == "dir" && b.type == "file") {
          return -1;
        }
        if (a.type == "file" && b.type == "dir") {
          return 1;
        }
      });
    },
    selectItem(item) {
      if (item.type != "dir") {
        this.itemSelected = item;
      } else if (item.type == "dir") {
        const toDir = item.path.replace(
          this.$store.state.config.dirs.root + "mediacenter/",
          this.$store.state.config.dirs.mediacenter
        );
        this.changeDir([toDir]);
      }
    },
    deselect() {
      this.itemSelected = { id: "" };
    },
  },
};
</script>

<style>
.item-repair {
  background: rgb(22, 22, 22) !important;
}
.item-repair:hover {
  cursor: pointer;
  background: rgb(39, 39, 39) !important;
}
.item-repair.selected {
  background: rgb(51, 83, 64) !important;
}
.pickerduration #timepicker {
  width: 310px;
}
.col_explorer {
  overflow-y: auto;
  max-height: 460px;
}
</style>
